import { useQueryClient } from "@tanstack/react-query";
import { FiRefreshCw } from "react-icons/fi";

import styles from "styles/chat.module.scss";
import httpErrorStatus from "utilities/httpErrorStatus";

interface MessagesReadErrorProps {
  threadId: string;
  error: Error;
  onReset: () => void;
}

export default function MessagesReadError({
  threadId,
  error,
  onReset,
}: MessagesReadErrorProps) {
  const queryClient = useQueryClient();
  const status = httpErrorStatus(error);

  const handleRetry = () => {
    queryClient.removeQueries({
      queryKey: ["cc-db-api", "threads", threadId, "messages"],
    });
    onReset();
  };

  const isAuthError = status === 401;
  const heading = status
    ? `${status}: Couldn't load messages`
    : "Couldn't load messages";
  const message = isAuthError
    ? "Your login session has expired. A page reload will start a fresh session."
    : "The server may be temporarily unavailable. Click retry to try again.";

  return (
    <main className={styles.chat + " vh-100-l vh-100-m"}>
      <div className={styles.chatBody + " pa3"}>
        <div className="center measure-wide pa2 pa0-ns tc">
          <h1 className="lh-title f2">{heading}</h1>
          <p className="f5 lh-copy">{message}</p>
          <details className="f6 mt1 mb3">
            <summary className="pointer">Error details</summary>
            <p className="code mt1">{error.message}</p>
          </details>
          {isAuthError ? (
            <button
              type="button"
              onClick={() => window.location.reload()}
              className={styles.actionButtonPrimary + " center"}
            >
              Reload page
            </button>
          ) : (
            <button
              type="button"
              onClick={handleRetry}
              className={styles.actionButtonPrimary + " center"}
            >
              <FiRefreshCw aria-hidden="true" />
              Retry
            </button>
          )}
        </div>
      </div>
    </main>
  );
}
